export default __webpack_public_path__ + "static/media/6N5A3838.c77e6a97.jpg";